import { useState } from "react";

export default function useSessionVariables() {

  const getAllSessionVariables = () => {
    const allVariableList = ["access_token", "login", "username"];
    let dummyObject = {};

    for (let i = 0; i < allVariableList.length; i++) {
      let value = sessionStorage.getItem(allVariableList[i]);
      if (value == null) continue;

      let parsedValue;

      try {
        parsedValue = JSON.parse(value);
      } catch (e) {
        // value is a plain string (like JWT)
        parsedValue = value;
      }

      if (
        typeof parsedValue === "object" &&
        parsedValue[allVariableList[i]] !== undefined
      ) {
        dummyObject[allVariableList[i]] = parsedValue[allVariableList[i]];
      } else {
        dummyObject[allVariableList[i]] = parsedValue;
      }
    }

    return dummyObject;
  };

  const [sessionVariables, setSessionVariables] = useState(getAllSessionVariables());

  const saveSessionVariableByField = (field, value) => {
    sessionStorage.setItem(field, JSON.stringify(value));
    setSessionVariables({
        ...sessionVariables,
        [field]: value,
    });
  }

  const saveSessionVariableByObject = (objectToSave) => {
    let dummyObject = {};
    for (let key in objectToSave){
      dummyObject = {
        [key]:  objectToSave[key]
      }
      sessionStorage.setItem(key, JSON.stringify(dummyObject));
    }
    setSessionVariables({
        ...sessionVariables,
        ...objectToSave,
    });
  }

  return {
    sessionVariables,
    saveSessionVariableByField,
    saveSessionVariableByObject
  };
}